import { render, staticRenderFns } from "./UserMessageParticipant.vue?vue&type=template&id=4a4d1e0e"
import script from "./UserMessageParticipant.vue?vue&type=script&lang=js"
export * from "./UserMessageParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports